module.exports = __webpack_public_path__ + "img/FullListOfAmenities.d2235967.png";